import i18 from '../../i18n';
import { PAGES } from '../pages';

export const utmaAccountMenu = [
  {
    title: i18.t('createAccount'),
    checked: true,
  },
  {
    title: i18.t('secureAccount'),
    path: PAGES.SECURE_ACCOUNT,
    nextPath: PAGES.SECURE_NAME,
    previousPath: PAGES.BASE,
    items: [
      {
        title: i18.t('name'),
        path: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_ACCOUNT,
      },
      {
        title: i18.t('phoneNumber'),
        path: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_NAME,
        preSkipPath: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_DOB,
      },
      {
        title: i18.t('dob'),
        path: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY,
        previousPath: PAGES.SECURE_PHONE_NUMBER,
      },
      {
        title: i18.t('identityVerification'),
        path: PAGES.SECURE_IDENTITY,
        nextPath: PAGES.SECURE_IDENTITY_SSN,
        previousPath: PAGES.SECURE_DOB,
        skipPath: PAGES.SECURE_IDENTITY_SSN,
        items: [
          {
            path: PAGES.SECURE_IDENTITY_SSN,
            nextPath: PAGES.SECURE_MINOR,
            previousPath: PAGES.SECURE_IDENTITY,
          },
        ],
      },
      {
        title: i18.t('minor'),
        path: PAGES.SECURE_MINOR,
        nextPath: PAGES.SECURE_MINOR_PHONE_NUMBER,
        previousPath: PAGES.SECURE_IDENTITY,
        preSkipPath: PAGES.SECURE_IDENTITY,
        items: [
          {
            path: PAGES.SECURE_MINOR_PHONE_NUMBER,
            previousPath: PAGES.SECURE_MINOR,
            preSkipPath: PAGES.SECURE_MINOR,
            nextPath: PAGES.SECURE_MINOR_DOB,
          },
          {
            path: PAGES.SECURE_MINOR_DOB,
            nextPath: PAGES.SECURE_MINOR_IDENTITY,
            previousPath: PAGES.SECURE_MINOR_PHONE_NUMBER,
          },
          {
            path: PAGES.SECURE_MINOR_IDENTITY,
            nextPath: PAGES.SECURE_MINOR_SSN,
            previousPath: PAGES.SECURE_MINOR_DOB,
            skipPath: PAGES.ADDRESS,
          },
          {
            path: PAGES.SECURE_MINOR_SSN,
            nextPath: PAGES.ADDRESS,
            previousPath: PAGES.SECURE_MINOR_IDENTITY,
            preSkipPath: PAGES.SECURE_MINOR_DOB,
          },
        ],
      },
    ],
  },
  {
    title: i18.t('address'),
    path: PAGES.ADDRESS,
    nextPath: PAGES.ADDRESS_ENTER,
    previousPath: PAGES.SECURE_MINOR_SSN,
    preSkipPath: PAGES.SECURE_MINOR_IDENTITY,
    items: [
      {
        path: PAGES.ADDRESS_ENTER,
        nextPath: PAGES.ADDRESS_MINOR,
        previousPath: PAGES.ADDRESS,
      },
      {
        path: PAGES.ADDRESS_MINOR,
        nextPath: PAGES.ADDRESS_MINOR_ENTER,
        previousPath: PAGES.ADDRESS_ENTER,
        skipPath: PAGES.ADDRESS_DONE,
      },
      {
        path: PAGES.ADDRESS_MINOR_ENTER,
        nextPath: PAGES.ADDRESS_DONE,
        previousPath: PAGES.ADDRESS_MINOR,
        skipPath: PAGES.ADDRESS_DONE,
      },
      {
        path: PAGES.ADDRESS_DONE,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        previousPath: PAGES.ADDRESS_MINOR_ENTER,
      },
    ],
  },
  {
    title: i18.t('fund'),
    path: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    nextPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
    previousPath: PAGES.ADDRESS_DONE,
    skipPath: PAGES.REVIEW,
    items: [
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.PLAID,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.WIRE,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CHECK,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CRYPTOCURRENCY,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
    ],
  },
  {
    title: i18.t('review'),
    path: PAGES.REVIEW,
    nextPath: PAGES.AGREEMENT,
    previousPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
    preSkipPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    items: [
      {
        path: PAGES.AGREEMENT,
        nextPath: '/',
        previousPath: PAGES.REVIEW,
      },
    ],
  },
];
